import { NgModule } from '@angular/core';
import { GuestFormService } from '../../auth/guest-registration/services/guest-form.service';

@NgModule({
  providers: [GuestFormService]
})
export class LandingsModule {}
